import { useEffect } from 'react';
import { listenDate } from '../../channels/dateChannel';
import { useDateStore } from '../../stores/useDateStore';

export function useDateChannel() {

    useEffect(() => {

        const unsubscribe = listenDate(({ tipo, payload }) => {

            const { setSelectedDate } = useDateStore.getState();

            if (tipo === 'date-upsert') {
                setSelectedDate(
                    payload.selectedDate,
                    false,
                    payload.manual
                );
            }

        });

        return unsubscribe;

    }, []);

}